import { render, staticRenderFns } from "./ETab.vue?vue&type=template&id=76b652d4&scoped=true"
import script from "./ETab.vue?vue&type=script&lang=js"
export * from "./ETab.vue?vue&type=script&lang=js"
import style0 from "./ETab.vue?vue&type=style&index=0&id=76b652d4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b652d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76b652d4')) {
      api.createRecord('76b652d4', component.options)
    } else {
      api.reload('76b652d4', component.options)
    }
    module.hot.accept("./ETab.vue?vue&type=template&id=76b652d4&scoped=true", function () {
      api.rerender('76b652d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/ETab.vue"
export default component.exports